import { makeAutoObservable } from 'mobx'

/**
 * Стор вкладки «Затримки» в картці заявки: стан модалки «Вирішити» (обрана затримка)
 * і перегляду фото затримки. Сам запит робить спільна
 * `Ship/Components/Modals/ResolveDelayModal` + `Ship/Stores/ResolveDelayModalStore`.
 */
export class TaskDelaysTabStore {
    open = false
    selectedDelay: any = null
    previewPhotos: string[] = []
    previewOpen = false

    constructor() {
        makeAutoObservable(this)
    }

    openResolveModal(delay: any): void {
        this.selectedDelay = delay
        this.open = true
    }

    closeResolveModal(): void {
        this.open = false
        this.selectedDelay = null
    }

    showPhotos(urls: string[]): void {
        this.previewPhotos = urls
        this.previewOpen = true
    }

    setPreviewOpen(open: boolean): void {
        this.previewOpen = open
    }
}
